import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import matrimonyInstance from "../utils/axios";
import {
	LIST_ACCOUNTS_TO_BE_VERIFIED,
	LIST_ALL_ACCOUNT_ADMIN,
	LIST_ALL_ACCOUNT_VOLUNTEER,
	LIST_ALL_PROFILES,
	LIST_BAT_ACCOUNTS,
	LIST_BAT_ACCOUNTS_FILTER,
	LIST_PROFILES_TO_BE_VERIFIED,
} from "../API_LIST";
import ProfileCard from "../component/section/profileCard";
import PaginationComponent from "../component/section/PaginatedItems";
import { getDataFromJwt, isUser } from "../utils/utility";
import Popup from "../component/section/popup";
import EditProfile from "./editProfile";
import { Link } from "react-router-dom";
import ROLES from "../utils/constants";
import PageTitle from "./pageTitle";
import AccountCard from "../component/section/accountCard";

export default function AccountsToBeVerified(props) {
	const navigate = useNavigate();
	const [profilesData, setProfilesData] = useState();
	const [pageData, setPageData] = useState([]);
	const [modalIsOpen, setIsOpen] = useState(false);

	const [totalCount, setTotalCount] = useState(null);
	const [filterProfile, setFilterProfile] = useState(null);

	const [pageNumber, setPageNumber] = useState(1);

	const [countPerPage, setCountPerPage] = useState(9);

	const roleid = getDataFromJwt("role");

	function getParent() {
		if (roleid) {
			return ROLES[roleid].landingUrl;
		}
	}
	const parent = getParent();

	const getProfiles = async (
		customCountPerPage,
		customPageNumber,
		filterProfile,
	) => {
		let filter = props.isUnVerified || filterProfile;
		let data = {
			limit: customCountPerPage
				? Number.parseInt(customCountPerPage)
				: countPerPage,
			page: customPageNumber ? Number.parseInt(customPageNumber) : pageNumber,
		};
		let userRole = getDataFromJwt("role");
		if (filter) data.filter_parameter = filterProfile;
		if (props.isUnVerified) data.filter_parameter = "in_progress";
		console.log({ data });
		if (props.isBatAccounts && filter) {
			matrimonyInstance
				.post(LIST_BAT_ACCOUNTS_FILTER, data)
				.then((response) => {
					setTotalCount(response.data.total_count);
					setPageNumber(response.data.page_number);
					setCountPerPage(response.data.limit);
					setProfilesData(response.data.accounts);
				});
		} else if (props.isBatAccounts) {
			matrimonyInstance
				.get(LIST_BAT_ACCOUNTS + `?page=${data?.page}&limit=${data?.limit}`)
				.then((response) => {
					setTotalCount(response.data.total_count);
					setPageNumber(response.data.page_number);
					setCountPerPage(response.data.limit);
					setProfilesData(response.data.accounts);
				});
		} else if (props.isMatrimonyAccounts && filter) {
			matrimonyInstance
				.post(LIST_PROFILES_TO_BE_VERIFIED, data)
				.then((response) => {
					setTotalCount(response.data.total_count);
					setPageNumber(response.data.page_number);
					setCountPerPage(response.data.limit);
					setProfilesData(response.data.accounts);
				});
		} else if (props.isMatrimonyAccounts) {
			const LIST_ALL_ACCOUNT =
				userRole === 1 ? LIST_ALL_ACCOUNT_ADMIN : LIST_ALL_ACCOUNT_VOLUNTEER;

			matrimonyInstance
				.get(LIST_ALL_ACCOUNT + `?page=${data?.page}&limit=${data?.limit}`)
				.then((response) => {
					setTotalCount(response.data.total_count);
					setPageNumber(response.data.page_number);
					setCountPerPage(response.data.limit);
					setProfilesData(response.data.accounts);
				});
		}
	};

	function onPageChanged(key, value) {
		if (key == "pageNumber") {
			setPageNumber(value);
			getProfiles(9, value, filterProfile);
		} else if (key == "countPerPage") {
			setCountPerPage(value);
			getProfiles(value, 1, filterProfile);
		}
	}

	useEffect(() => {
		getProfiles();
	}, [props.isBatAccounts, props.listAll]);

	function closeModal() {
		setIsOpen(false);
	}
	let pageTitle;
	if (isUser()) {
		pageTitle = <PageTitle pageName={"Your Profiles"} />;
	} else if (props.isBatAccounts && props.isUnVerified) {
		pageTitle = <PageTitle pageName={"Bat Accounts to be verified"} />;
	} else if (props.isBatAccounts) {
		pageTitle = <PageTitle pageName={"BAT Accounts"} />;
	} else if (props.isMatrimonyAccounts) {
		pageTitle = <PageTitle pageName={"Matrimony Accounts"} />;
	}
	return (
		<React.Fragment>
			<h6 className="d-flex align-items-center pt-25">{pageTitle}</h6>
			<div className="d-flex justify-content-end align-items-center mr-30 mb-20">
				{isUser() ? (
					<span onClick={() => setIsOpen(true)} className="cursor-pointer">
						<img
							src="../assets/images/bat-img/add-profile.svg"
							className="add-profile mr-10"
						/>
						Create Matrimony Profile
					</span>
				) : null}
			</div>
			{!props.isUnVerified ? (
				<div className="d-flex flex-column align-items-start pt-10 pl-30">
					<div className="d-flex gap-2 align-items-center  pl-10">
						<span>Showing</span>
						<select
							style={{ width: "max-content" }}
							className="form-select"
							value={filterProfile}
							onChange={(e) => {
								setFilterProfile(e.target.value);
								getProfiles(9, 1, e.target.value);
							}}
						>
							<option value={""}>All accounts</option>
							<option value={"approved"}>Approved accounts</option>
							<option value={"declined"}>Rejected accounts</option>
							<option value={"in_progress"}>
								Verification pending accounts
							</option>
						</select>
					</div>
				</div>
			) : null}
			<div className="d-flex justify-content-center pb-30 pt-10">
				<div className="profile-card-list">
					<AccountCard
						accountsData={profilesData}
						showShortList={true}
						isBatAccounts={props.isBatAccounts}
					/>
				</div>
			</div>
			<Popup
				modalIsOpen={modalIsOpen}
				closeModal={closeModal}
				html={<EditProfile />}
			/>
			
				<PaginationComponent
					totalCount={totalCount}
					onValueChanged={onPageChanged}
					pageNumber={pageNumber}
					countPerPage={countPerPage}
				/>
		</React.Fragment>
	);
}
